import { IGTFSValidationResult } from "../interfaces/endpoints/IGTFS.types";

const getCdnBase = () =>
  process.env.REACT_APP_CDN_API_URL || "https://w3mhh8jtzt.gjirafa.net/travel";

export const getLatestFeedUrl = (): string =>
  `${getCdnBase()}/gtfs/gtfs-latest.zip`;

export const getFeedUrl = (validation: IGTFSValidationResult): string => {
  if (validation.feedUrl) return validation.feedUrl;
  const date = new Date(validation.generatedAt);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2);
  const version = Number(validation.feedVersion);
  const versionStr = Number.isNaN(version) ? "0" : version.toFixed(1);
  const fileName = `GTFS-${versionStr}-${dd}.${mm}.${yy}.zip`;
  return `${getCdnBase()}/gtfs/${fileName}`;
};
